import { useEffect, useState } from "react";
import { _AbstractAccount, _AccountINFORPO, _Affiliate, _RequestCreditInfo, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { AccountEditor } from "../../../editor/AccountEditor";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { CardTaps } from "../../../theme/Component/CardTaps";
import { AmortizationCreditInfo } from "../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/AmortizationCreditInfo";
import { HistoryCreditInfo } from "../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/HistoryCreditInfo";
import useModal, { MODAL_LG, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { PersonalAccountData } from "../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { RequestCreditInfo } from "./RequestCreditInfo/RequestCreditInfo";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { MyEditor } from "../../../theme/Component/MyEditor";
import { AtachDocument } from "../../../theme/Component/AtachDocument";
import { PrintJson } from "../../../theme/Component/PrintJson";

export const ThirdContactInfo = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AccountINFORPO);
    const info = useDataBean(_RequestCreditInfo);

    const acc = useDataBean(_Affiliate);
    const paginador = usePaginator();

    const [idAccount, setIDAccount] = useState<number>();
    const [account, setAccount] = useState<any>({});

    const modalUser = useModal(`Informacion de ${account.PrimerNombre} ${account.PrimerApellido}`, MODAL_XL)
    const modalAddInfo = useModal(`Agregar Registro de Comuncación`, MODAL_LG)
    const modalAtentions = useModal(`Registros de Comunicación de ${account.PrimerNombre} ${account.PrimerApellido}`, MODAL_XL)
    const modalCreditInfo = useModal(`Detalles del credito ${bean.CreditNumber}`, MODAL_XL)

    useEffect(() => {
        if (idAccount) {
            getCredits(idAccount);
        }
    }, [idAccount])

    const getCredits = (id: number) => {
        const props = {
            "IDAccount": idAccount
        }

        acc.instance.getAffiliateCatalogPorPropiedades(props, null).then(
            (resp) => {
                if (resp.length > 0) {
                    setAccount(resp[0].DataBeanProperties)
                } else {
                    toast.error("no se encontro información del usuario")
                }
            }
        ).catch(
            err => { toast.error(err) }
        )

        let p = {
            ...props,
            Year: _single.getCurrenYear(),
            Month: _single.getCurrentMonth()
        };

        instance.getCarteraRender(paginador.page, 15, p).then(
            (resp) => {
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const updateItemInfo = () => {
        info.instance.updateRequestCreditInfo(info.bean).then(
            (resp) => {
                toast.success("Registro Agregado");
                modalAddInfo.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const createInfoRegister = () => {
        modalAddInfo.open();
        info.setBean({
            IDAccount: idAccount,
            IDEmployee: _single.getAccountID(),
            IDCreditAccount: bean.IDCreditAccount,
            State: 1
        });
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Agregar Registro de Comunicación', icono: 'ri-add-line', visible: _single.canCreate(), evento: () => { createInfoRegister(); } },
            {
                titulo: 'Detalles', icono: 'ri-list-check', visible: true, evento: () => {
                    modalCreditInfo.open();
                    setIndexTap(0);
                }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const head = [
        { title: 'ID', property: 'IDCreditAccount', visible: false, mask: MASK_NUMBER },
        { title: '# Credito', property: 'CreditNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Valor Crédito', property: 'AmountCredit', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Crédito', property: 'CurrentCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Linea Crédito', property: 'NameLoanLine', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Registros de Comunicación', disable: false },
        { id: 1, name: 'Amortización del Credito', disable: false },
        { id: 2, name: 'Historial del Credito', disable: false }
    ];

    const [document, setDocument] = useState<any>([]);

    useEffect(() => {
        info.setBean({ ...info.bean, JSONMedia: JSON.stringify(document) })
    }, [document]);

    return (
        <BasicPage titulo="Registro de Atención al Usuario" >
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <AccountEditor idAccount={idAccount} label="Tercero" onChange={(e) => { setIDAccount(e.IDAccount); }} />
                </div>
                {account.IDAccount &&
                    <div className="col-md-3 d-flex justify-content-center">
                        <BasicButton useMargin eventClick={() => { modalAtentions.open(); }} icon="ri-list-check-2" children={"Ver Registros de Comunicación"} />
                    </div>
                }
                {account.IDAccount &&
                    <div className="col-md-10 mt-3">
                        <div className="card pointer" onClick={() => { modalUser.open() }}>
                            <div className="card-header text-center" style={{ color: "#ca4e07" }}>
                                Datos del Usuario
                            </div>
                            <div className="card-body" style={{ maxHeight: "20dvh", overflow: "auto" }}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Numero de Documento:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.Nit }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }} >Nombres y Apellidos:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${account.PrimerNombre} ${account.SegundoNombre} ${account.PrimerApellido} ${account.SegundoApellido}` }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Fecha de Nacimiento:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.FechaNacimiento }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Dirección Residencia:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.DireccionResidencia }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Tiempo de Servicio:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.TiempoServicio }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Correo:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.CorreoPersonal }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Correo Institucional:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.CorreoInstitucional }}></div>
                                    </div>
                                    <div className="col-md-6">
                                        <strong style={{ color: "rgb(59 64 139)" }}>Celular:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: account.NumeroCelular }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
            {account.IDAccount &&
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header text-center" style={{ color: "#ca4e07" }}>
                            Créditos de {account.PrimerNombre} {account.SegundoNombre} {account.PrimerApellido} {account.SegundoApellido}
                        </div>
                        <div className="card-body">
                            <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                        </div>
                    </div>
                </div>
            }

            <Modal modal={modalUser.modal} updateModal={modalUser.setModal} >
                <PersonalAccountData idAffiliate={idAccount} />
            </Modal>

            <Modal modal={modalCreditInfo.modal} updateModal={modalCreditInfo.setModal} >
                <div className="row">
                    <div className="col-md-12">
                        <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                            <div className="row">
                                {indexTap === 0 &&
                                    <RequestCreditInfo isModal _IDAccount={idAccount} _CreditID={bean.IDCreditAccount} />
                                }
                                {indexTap === 1 &&
                                    <div className="col-md-12">
                                        <AmortizationCreditInfo Credit={bean} _idAccount={idAccount} />
                                    </div>
                                }
                                {indexTap === 2 &&
                                    <div className="col-md-12">
                                        <HistoryCreditInfo Credit={bean} _idAccount={idAccount} />
                                    </div>
                                }

                            </div>
                        </CardTaps>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalAddInfo.modal} updateModal={modalAddInfo.setModal} eventModal={() => { updateItemInfo() }} >
                <div className="row">
                    <div className="col-md-6">
                        <label>Tipo de Contacto</label>
                        <select className="form-select" value={info.bean.ContactType} onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            info.setBean({ ...info.bean, ContactType: value })
                        }}>
                            <option value="">...</option>
                            <option value="100">Telefono</option>
                            <option value="101">Presencial</option>
                            <option value="102">Correo</option>
                            <option value="103">WhatsApp</option>

                        </select>
                    </div>
                    <div className="col-md-6">
                        <label>Numero de Caso</label>
                        <input type="text" className="form-control" value={info.bean.TicketNumber} onChange={(e) => { info.setBean({ ...info.bean, TicketNumber: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <AtachDocument _docList={document} onChange={(e) => { setDocument(e) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>
                        <textarea onChange={(e) => { info.setBean({ ...info.bean, Observation: e.target.value }) }} value={info.bean.Observation} className="form-control"></textarea>
                        {/* <MyEditor onChange={(e) => { info.setBean({ ...info.bean, Observation: e }) }} val={info.bean.Observation} /> */}
                    </div>
                    {/* <PrintJson json={info.bean}/> */}
                </div>
            </Modal>

            <Modal modal={modalAtentions.modal} updateModal={modalAtentions.setModal} >
                <RequestCreditInfo isModal _IDAccount={idAccount} />
            </Modal>
        </BasicPage>
    )
}